import React from "react";
import styles from "./styles.module.scss";
import { getUrl } from "@helpers/switchLanguage";
import { Languages } from "@genericTypes/sharedTypes";
import {
    socialMediaShareLinks,
    socialMediaShareLinksMobile,
} from "@lib/sharedUtils";

const Share = ({
    contentToBeSharedUrl,
    secondStyle = false,
}: {
    contentToBeSharedUrl: string;
    secondStyle?: boolean;
}) => {
    if (secondStyle) {
        return (
            <div className={`lg:hidden flex  gap-1 mt-4`}>
                {socialMediaShareLinksMobile?.map((el, index) => (
                    <a
                        key={index}
                        className={`cursor-pointer `}
                        onClick={() => {
                            window.open(
                                `${el.link}${getUrl(
                                    process.env
                                        .NEXT_PUBLIC_DEFAULT_LANG as Languages,
                                    contentToBeSharedUrl,
                                )}`,
                                "",
                                "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600",
                            );
                            return false;
                        }}
                    >
                        {el.icon}
                    </a>
                ))}
            </div>
        );
    }
    return (
        <>
            {socialMediaShareLinks?.map((el, index) => (
                <a
                    key={index}
                    className={`cursor-pointer  ${styles[el.name]}`}
                    onClick={() => {
                        window.open(
                            `${el.link}${getUrl(
                                process.env
                                    .NEXT_PUBLIC_DEFAULT_LANG as Languages,
                                contentToBeSharedUrl,
                            )}`,
                            "",
                            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600",
                        );
                        return false;
                    }}
                >
                    {el.icon}
                </a>
            ))}
        </>
    );
};

export default Share;
